const initState = {}

const reduxReducer = (state = initState, action) => {
  const payload = action.payload;
  switch (action.type) {
    
    case 'UPDATE_REDUX_RESTAURANTS_SUCCESS':
      //console.log('update redux restaurants success')
      return ({...state, restaurants:payload})

    case 'UPDATE_REDUX_USERS_SUCCESS':
      //console.log('update redux users success')
      return ({...state, users:payload})

    case 'UPDATE_REDUX_USER_SUCCESS':
      //console.log('update redux user success')
      return ({...state, user:payload})

    case 'UPDATE_REDUX_USER_REVIEWS_SUCCESS':
      //console.log('update redux user reviews success')
      return ({...state, userReviews:payload})


    case 'UPDATE_REDUX_REVIEWS_SUCCESS':
      //console.log('update redux reviews success')
      return ({...state, restaurantReviews:payload})

    case 'UPDATE_REDUX_PENDING_REVIEWS_SUCCESS':
      //console.log('update redux pending reviews success')
      return ({...state, pendingReviews:payload})

    case 'UPDATE_REDUX_PENDING_SUCCESS':
      //console.log('update redux pending success')
      return ({...state, pending:payload})

    case 'UPDATE_REDUX_PENDING_CREATE_SUCCESS':
      //console.log('update redux pending create success')
      return ({...state, pendingCreate:payload})


    default:
      return state;
  }
};

export default reduxReducer;